import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SafePipe } from 'safe-pipe';
import { CommonModule } from '@angular/common';
import { FlimmoMetaService } from '../../../core/services/flimmo-meta.service';
import { SubSink } from 'subsink';
import { PreviewItem, Source, Swimlane } from '../../../generated-api';
import { formatDate } from '../../functions/utils';
import * as Constants from '../../../core/helpers/constants/constants';
import ItemclassEnum = PreviewItem.ItemclassEnum;

@Component({
  selector: 'verticallanes',
  templateUrl: './verticallanes.component.html',
  styleUrls: ['./verticallanes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  //imports: [CommonModule, SafePipe, RouterModule],
  host: { ngSkipHydration: 'true' },
})
export class VerticallanesComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private _swimlane: Swimlane;
    public get swimlane(): Swimlane {
      return this._swimlane;
    }
  
    @Input()
    public set swimlane(value: Swimlane) {
      this._swimlane = value;
      this.swimlaneLinks = value.items.map((item) => this.generatelinks(item));
    }
  
    swimlaneLinks: string[];
    @Input() loading = false;
    @Input() bigCards = false;
    @ViewChild('container') container: ElementRef;
    @Input() tvLane = false;
  
    sic = ItemclassEnum;
    subs = new SubSink();
    currentDate = formatDate(new Date());
    private leftAtLimit = true;
    private rightAtLimit = false;
    private cardWidth = 160;
    private gap = 15;
  
    @HostListener('window:resize', ['$event'])
    onResize(): void {
      this.cr.detectChanges();
      this.cr.markForCheck();
    }
  
    readonly PLACEHOLDER_IMAGE_WITH_PATH = Constants.PLACEHOLDER_IMAGE_WITH_PATH;

  constructor(
    public flimmoMeta: FlimmoMetaService,
    private cr: ChangeDetectorRef,
    private router: Router
  ) { }

  ngAfterViewInit(): void {
    this.cr.detectChanges();
    this.cr.markForCheck();
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cr.detectChanges();
    this.cr.markForCheck();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  open(url: string): void {
    this.router.navigateByUrl(url);
  }

  generatelinks(m: PreviewItem): string {
    if (m.itemclass === this.sic.Besprechung) {
      return `/besprechung/${m.id}/${this.flimmoMeta.prettifyUrl(m.title)}`;
    } else if (m.itemclass === this.sic.Ytbesprechung) {
      return `/ytbesprechung/${m.id}/${this.flimmoMeta.prettifyUrl(m.title)}`;
    } else if (m.itemclass === this.sic.Redtext) {
      let title = m.title
      if (!title && m.topos) {
        title = m.topos
      }
      return `/redtext/${m.id}/${this.flimmoMeta.prettifyUrl(title)}`;
    } else if (m.itemclass === this.sic.Special) {
      return `/special/${m.id}/${this.flimmoMeta.prettifyUrl(m.title)}`;
    }
    return `/`;
  }

  onImageError(event): void {
    event.target.src = Constants.PLACEHOLDER_IMAGE_WITH_PATH;
  }

  getText(srclist: Array<Source>): string {
    return srclist
      .sort(
        (a, b) =>
          this.srcSequence.indexOf(a.src) - this.srcSequence.indexOf(b.src)
      )
      .map((value) => value.srcName)
      .join(', ');
  }

  hasSrc(m: PreviewItem): boolean {
    return (
      (m.itemclass === this.sic.Besprechung ||
        m.itemclass === this.sic.Ytbesprechung) &&
      m.srclist &&
      m.srclist.length > 0
    );
  }

  getAlterText(ageCategory): string {
    switch (ageCategory) {
      case 3:
        return 'searchList.selectors.ageOptionsAlt.3';
      case 5:
        return 'searchList.selectors.ageOptionsAlt.5';
      case 7:
        return 'searchList.selectors.ageOptionsAlt.7';
      case 9:
        return 'searchList.selectors.ageOptionsAlt.9';
      case 11:
        return 'searchList.selectors.ageOptionsAlt.11';
    }
  }


  srcSequence = [
    'kino',
    'netflix',
    'amazon',
    'disney_plus',
    'kika',
    'toggo',
    'ARD Mediathek',
    'ZDF Mediathek',
    'RTLPLUS',
    'Joyn',
    'joyn',
    'filmfriend',
    'youtube',
    'youtubekids',
    'tiktok',
    'instagram',
    'tv',
    'KKA',
    'RTLS',
    'Disney Channel Free TV',
    'NICK',
    'RTL',
    'RTL2',
    'PRO7',
    'SAT1',
    'K1',
    'ARD',
    'ZDF',
  ];

}
